import {
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import { ApplicationStore, getModuleGroupByName, SOFTLINE_FEATURE_APPLICATIONS } from '@softline/application';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { provideSoftAppsModule, withLazySoftAppsModuleTranslation, withSoftAppsModuleRoutes } from '@softapps/core';
import { default as de } from '../i18n/de.json';
import { default as deTitles } from '../i18n/de.titles.json';
import { SOFTLINE_PERMISSION_LAGERSTAND } from './lagerstand.shared';
import { lagerstandRoutes } from './lagerstand.routes';

export const lagerstandProviders: (Provider | EnvironmentProviders)[] = [
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'lagerstand',
      language: 'de',
      translations: de,
    });
    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: '#LAGERSTAND.APP',
      description: '#LAGERSTAND.APP_DESC',
      icon: 'fa-regular fa-boxes-stacked',
      route: '/lagerstand',
      permission: SOFTLINE_PERMISSION_LAGERSTAND,
      group: getModuleGroupByName('Lager'),
    });
  }),
];

export function provideLagerstandModule() {
  return [
    provideSoftAppsModule(
      {
        name: 'lagerstand',
        title: '#LAGERSTAND.APP',
        description: '#LAGERSTAND.APP_DESC',
        icon: 'fa-regular fa-boxes-stacked',
        route: '/lagerstand',
        permission: SOFTLINE_PERMISSION_LAGERSTAND,
        group: getModuleGroupByName('Lager'),
      },
      withSoftAppsModuleRoutes({ app: lagerstandRoutes }),
      withLazySoftAppsModuleTranslation({
        eager: { de: deTitles },
        lazy: { de: () => import('../i18n/de.json') },
      })
    ),
  ];
}
